import { AuthForm } from "comps";

const Register = () => <AuthForm mode="register" />;

export default Register;
